import type { Event as BugsnagEvent } from "@bugsnag/js";

type BugsnagError = BugsnagEvent["errors"][number];

const OWN_BUNDLE_PATH = "/_next/";

// Browsers inject scripts (password managers, in-page translation, in-app
// webviews) that run with the HTML document as their source. An error is ours
// only when a frame points at our bundles.
export const isInjectedScriptError = (error: BugsnagError): boolean =>
  error.type === "browserjs" &&
  error.stacktrace.length > 0 &&
  !error.stacktrace.some(({ file }) => file?.includes(OWN_BUNDLE_PATH));
